module.exports = {
	"description": "CardTitle displays a Card title and an optional subtitle.\nYou can put CardTitle in any order in relation to other root components of [Card]('./card').",
	"methods": [],
	"props": {
		"meta": {
			"flowType": {
				"name": "string"
			},
			"required": false,
			"description": "Information displayed above the title"
		},
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": true,
			"description": "Title of the Card"
		},
		"minor": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Displays the title in a less important style"
		},
		"subtitle": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "Subtitle displayed under the title"
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Card/CardTitle.js
// module id = 1603
// module chunks = 0